import React from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import Util from '../../../helper/Util';
import { Translate } from '../../../localization';
import { Grid } from '@material-ui/core';
import MainBet from '../../Shared/MainBet';
import { useSelector } from 'react-redux';

const MatchBanner = (props) => {
  const { item } = props;
  const { language } = useSelector((state) => state.general);
  const lan = `name_${ language }`;
  const {
    participant_one: participantOneId,
    participant_two: participantTwoId,
    league,
    // location,
    // fixture_status: status,
    participants,
    start_date: scheduleTime,
    fixture_id: matchID,
    market,
    location,
  } = item;

  let isMarketPresent = false;
  let betData = Object.values(market)[0].col;
  if (market && Object.values(market)[0].Bets) {
      isMarketPresent = true;
      betData = Object.values(market)[0].Bets;
      betData = Object.values(betData);
  }

  let teamNames = [];
  if (participants) teamNames = [ participants?.[0][ lan ] || participants?.[0].name_en, participants?.[1][ lan ] || participants?.[1].name_en ];
  let locationName = location[ lan ] || location?.name_en;
  let currentDate = {};
  let dateString = '';
  let timeString = '';
  if(scheduleTime) {
    currentDate = Util.convertToLocalTimezone(scheduleTime);
    dateString = currentDate.dateString;
    timeString = currentDate.timeString;
  }

  const spacesForTeamA = teamNames[ 1 ]?.length - teamNames[ 0 ]?.length;
  const spacesForTeamB = teamNames[ 0 ]?.length - teamNames[ 1 ]?.length;

  const getSpaces = (num) => ' '.repeat(num);

  return (
      <>
          {/* <a key={ `banner_${ matchID }` } href={ `/d/extra-market/${item.sport_id}/${item.fixture_id}`}>
              <div className='w-100 slider-content-wrap d-inline-block'>
                  <img src='/images/match-banner.png' className='carousel-banner-img' height='160' />
                  <div className='slider-content d-flex align-items-center'>
                      <div className="team-card-wrap">
                          <div className="team-card-header d-flex justify-content-between align-items-center my-1">
                              <div>
                                  <i className="icon-color icon-football lh-0 banner-sport-icon"></i>
                                  <span className='pl-2 league-name'>{ league.name_en }</span>
                              </div>
                              <div className="team-card-header-right d-flex align-items-center">
                                  <div className="match-time-wrap">
                                      <span>{ dateString}</span>
                                      <span className='pl-2'>{ timeString }</span>
                                  </div>
                              </div>
                          </div>
                          <Grid container className="team-card-content d-flex justify-content-between align-items-center mb-1 mx-0">
                              <Grid item xs={ 5 } className="team-one-content d-flex text-right align-items-center">
                                  <h4 title={ teamNames[ 0 ] } className='team-name'>
                                      { spacesForTeamA > 1 ? getSpaces(spacesForTeamA / 2) : ''}
                                      { teamNames?.length ? teamNames[ 0 ] : '' }
                                      { spacesForTeamA > 1 ? getSpaces(spacesForTeamA / 2) : ''}
                                  </h4>
                                  <img className='team-logo' alt='' src={`https://img.sportradar.com/ls/crest/medium/${participantOneId}.png`}/>
                              </Grid>
                              <Grid item xs={ 2 } className="match-score-wrap">
                                  <div className='center-banner-content'>
                                      <span className='team-logo-top-center'>
                                          { '- : -' }
                                      </span>
                                      <span className='team-logo-center max-width-33 '>
                         
                                      </span>
                                  </div>
                              </Grid>
                              <Grid item xs={ 5 } className="team-second-content d-flex text-left align-items-center">
                                  <img className='team-logo' alt='' src={`https://img.sportradar.com/ls/crest/medium/${participantTwoId}.png`}/>
                                  <h4 title={ teamNames[ 1 ] } className='team-name'>
                                      { spacesForTeamB > 1 ? getSpaces(spacesForTeamB / 2) : ''}
                                      { teamNames?.length ? teamNames[ 1 ] : '' }
                                      { spacesForTeamB > 1 ? getSpaces(spacesForTeamB / 2) : ''}
                                  </h4>
                              </Grid>
                          </Grid>
                          <div className="match-result-wrap">
                              <h5>Match Result</h5>
                              <div className="match-result-dodson-wrap d-flex justify-content-between">
                                  { isMarketPresent ? betData.map(bet => (
                                      <MainBet fixture={item} market={Object.values(market)[0]} bet={bet} key={bet.Id} type='banner' leagueName={league.name_en} />
                              )) : betData.map(bet => (
                                  <div className="match-result-oddbox">
                                      <span className="match-result-left">
                                          { bet }
                                      </span>
                                      <i className="material-icons"> lock </i>
                                  </div>
                              ))}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </a> */}
      
          <li  key={ `banner_${ matchID }` } >
              <a href={ `/${Translate.getLanguage()}/d/extra-market/${item.sport_id}/${item.fixture_id}`}>
                  <div className="match-card">
                      <div className='event-detail-sec d-flex justify-content-between'>
                          <div className='game-date d-flex align-items-center'>
                              <i class='fas fa-futbol mr-1'></i>
                              <span className='detail-main d-flex'>
                                  <p>{ dateString }</p>
                                  <span> . </span>
                                  <p> { timeString } </p>
                              </span>
                          </div>
                          <span>&nbsp;</span>
                          <div className='game-team d-flex'>
                              <p>{ league[ lan ] || league.name_en }</p>
                              <span>&nbsp;</span>
                              <p>{ locationName }</p>
                          </div>
                      </div>
                      <div className='team-details'>
                          <div className='team-name-banner'>
                              <p>{ teamNames[ 0 ] } </p>
                              <p>{ teamNames[ 1 ] }</p>

                          </div>
                          <div className='live-stats'>
                              <i class="fa fa-bar-chart"></i>
                              <p>1X2</p>
                          </div>
                      </div>
                      <ul className='bets-detail-content'>
                          { isMarketPresent ? betData.map(bet => (
                              <MainBet fixture={item} market={Object.values(market)[0]} bet={bet} key={bet.Id} type='banner' leagueName={league[ lan ] || league.name_en} />
                              )) : betData.map(bet => (
                                  <div className="match-result-oddbox text-white">
                                      <span className="match-result-left">
                                          { bet }
                                      </span>
                                      <i className="material-icons text-white"> lock </i>
                                  </div>
                              ))}
                      </ul>
                  </div>
              </a>
          </li>
      </>
  );
};

MatchBanner.defaultProps = {
  timeZone: 'Africa/Dakar',
};

MatchBanner.propTypes = {
  item: PropTypes.arrayOf(PropTypes.any).isRequired,
  timeZone: PropTypes.string,
};

export default MatchBanner;
